// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2MPgj","question":"Question_question__1nFYT","description":"Question_description__1mv-V"};